// src/pages/packageDefinitions/components/PackageDefinitionsFilters.jsx
import React, { useMemo } from "react";
import GenericTableFilter from "../../../components/common/GenericTableFilter";


export default function PackageDefinitionsFilters({
    filterFields,
    columns,
    customFilterTypes,
    customFilterOptions,
    handleSearch,
    handleApplyFilters,
    handleResetFilters,
}) {
    const initialFilters = useMemo(() => ({}), []);


    return (
        <GenericTableFilter
            filterFields={filterFields}
            columns={columns}
            initialFilters={initialFilters}
            onSearch={handleSearch}
            onApplyFilters={handleApplyFilters}
            onResetFilters={handleResetFilters}
            customFilterTypes={customFilterTypes}
            customFilterOptions={customFilterOptions}
        />
    );
}